// extracted by mini-css-extract-plugin
export default {"uploadDocumentWrapper":"UploadDocumentOrganism_uploadDocumentWrapper__6MKnr"};